import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

import {
    Button,
    FontVariant,
    type TextVariant,
    Text,
    TextHeading,
} from '@pexip/components';

import type {Idp} from '../../types';
import {TestId} from '../../../test/testIds';

export const SelectIdp: React.FC<{
    handleIdp: (
        chosenIdp: string,
        redirectUrl?: string,
        disablePopupFlow?: boolean,
    ) => void;
    idps: Idp[];
    headingText?: string;
    descriptionText?: string;
    headingFontVariant?: FontVariant;
    descriptionVariant?: TextVariant;
    descriptionFontVariant?: FontVariant;
    descriptionClassName?: string;
}> = ({
    handleIdp,
    idps,
    headingText,
    descriptionText,
    headingFontVariant = FontVariant.H4,
    descriptionVariant = 'subtle',
    descriptionFontVariant = FontVariant.H6,
    descriptionClassName,
}) => {
    const {t} = useTranslation();
    return (
        <>
            <TextHeading
                htmlTag="h2"
                fontVariant={headingFontVariant}
                className="mb-2"
            >
                {headingText ?? (
                    <Trans t={t} i18nKey="idp.sign-in">
                        Sign in
                    </Trans>
                )}
            </TextHeading>
            <Text
                fontVariant={descriptionFontVariant}
                variant={descriptionVariant}
                className={descriptionClassName}
            >
                {descriptionText ?? (
                    <Trans t={t} i18nKey="idp.select-provider">
                        You will be redirected to the selected Identity
                        Provider.
                    </Trans>
                )}
            </Text>
            {idps.map(({name, redirectUrl, uuid, disablePopupFlow}) => (
                <Button
                    modifier="fullWidth"
                    className="mt-4"
                    size="large"
                    key={uuid}
                    onClick={() =>
                        handleIdp(uuid, redirectUrl, disablePopupFlow)
                    }
                    data-testid={`${TestId.ButtonSignInWith}-${name
                        .replace(/ /g, '-')
                        .toLowerCase()}`}
                >
                    <Trans t={t} i18nKey="idp.sign-in-with">
                        Sign in with {{name}}
                    </Trans>
                </Button>
            ))}
        </>
    );
};
